import { QrcodeScanScreenNavigationProps } from "./types"
import React from "react"
import QrcodeScan from "./qrcode-scan-screen"
import { PageRoot } from "~screens/page-root"


const QrcodeScanScreen: React.FC<QrcodeScanScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <QrcodeScan />
    </PageRoot>
  )
}

export default QrcodeScanScreen
